export interface Auth {
    readonly id: number;
    accessToken: string;
    tokenExpires: Date;
    mustChangePassword?: boolean;
}

export const isAuth = (x: unknown): x is Auth =>
    typeof x === 'object' &&
    'id' in x &&
    typeof x.id === 'number' &&
    'accessToken' in x &&
    typeof x.accessToken === 'string' &&
    'tokenExpires' in x &&
    x.tokenExpires instanceof Date &&
    (!('mustChangePassword' in x) || typeof x.mustChangePassword === 'boolean');

export interface AuthJSON {
    readonly id: number;
    readonly accessToken: string;
    readonly tokenExpires: string;
    readonly mustChangePassword?: boolean;
}

export const isAuthJSON = (x: unknown): x is AuthJSON =>
    typeof x === 'object' &&
    'id' in x &&
    typeof x.id === 'number' &&
    'accessToken' in x &&
    typeof x.accessToken === 'string' &&
    'tokenExpires' in x &&
    typeof x.tokenExpires === 'string' &&
    (!('mustChangePassword' in x) || typeof x.mustChangePassword === 'boolean');
